export default __webpack_public_path__ + "static/media/1-grinning-face_1f600.dcafbc95.png";